<template>
  <div ref="container" class="ns-animate-height" data-testid="height-container">
    <div ref="content">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
export default {
  name: 'NsAnimateHeight',
  props: {
    /**
     * Whether the content is visible or not
     */
    open: Boolean,
  },
  data() {
    return {
      timeoutId: null,
      contentObserver: null,
    };
  },
  watch: {
    open: {
      immediate: false,
      handler(open) {
        this.animate(open);
      },
    },
  },
  mounted() {
    window.addEventListener('resize', this.animate);
    this.contentObserver = new MutationObserver(() => this.animate(this.open));
    this.contentObserver.observe(this.$refs.content, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });

    this.animate(this.open);
  },
  destroyed() {
    window.removeEventListener('resize', this.animate);

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.contentObserver.disconnect();
  },
  methods: {
    animate(open) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      if (typeof open === 'boolean' ? open : this.open) {
        const height = this.$refs.content.scrollHeight;
        if (this.$refs.container) {
          this.$refs.container.style.maxHeight = height + 'px';

          // once opened, allow inner elements to overflow
          this.timeoutId = setTimeout(() => {
            this.$refs.container.style.overflow = 'unset';
          }, 225);
        }
      } else if (this.$refs.container) {
        // when closed, do not allow inner elements to overflow
        this.$refs.container.style.overflow = null;
        this.$refs.container.style.maxHeight = '0px';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ns-animate-height {
  overflow: hidden;
  transition: max-height 0.225s ease;
}
</style>
